import ScmPageRenderer from '@/components/scm/ScmPageRenderer';
import { shipmentTrackingPageDef } from '@/components/scm/scm-page-defs';

export default function ScmShipmentTrackingPage() {
  return <ScmPageRenderer pageDef={shipmentTrackingPageDef} />;
}
